import { render, staticRenderFns } from "./AccordionRecipeTile.vue?vue&type=template&id=6e20b852"
import script from "./AccordionRecipeTile.vue?vue&type=script&lang=js"
export * from "./AccordionRecipeTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports